import type { SessionState } from "@/convex/session";

/** Whether any user account is linked to the session's reader; `null` is unknown. */
export function linkedOf(state: SessionState): boolean | null {
  if (state.status !== "ready") return null;
  return state.session.linked;
}

// ../app keyed its menu off `session.method`: "anonymous" got the name,
// save and reset items; a signed-in reader got "Signed in as" and sign-out.
// Here every device reads under a reader_session, so "anonymous" is a
// reader_session no account is known to be linked to.
export type UserMenuView =
  | { kind: "pending" }
  | { kind: "sign-in" }
  | { kind: "account-without-reader" }
  | { kind: "unlinked-reader"; readerId: string; linkKnown: boolean }
  | { kind: "signed-in-reader"; readerId: string };

export function userMenuViewOf(state: SessionState): UserMenuView {
  switch (state.status) {
    case "loading":
    case "unavailable":
      return { kind: "pending" };
    case "signed-out":
      return { kind: "sign-in" };
    case "ready": {
      const { readerId } = state.session;
      if (readerId === null) return { kind: "account-without-reader" };
      const signedIn =
        state.session.lane === "user_session" || linkedOf(state) === true;
      return signedIn
        ? { kind: "signed-in-reader", readerId }
        : {
            kind: "unlinked-reader",
            readerId,
            linkKnown: linkedOf(state) !== null,
          };
    }
  }
}
